import api from "../axios";

export const getUserList = () => {
    return api.get("/grant/list/");
};

export const updateUserGrants = (userId, data) => {
    return api.patch(`/grant/update/${userId}`, data);
};